import React from 'react';
import { gql } from '../../graphql/generated/gql';
import type { ExtractReactionThreadTypes } from '../../utils/post/threadUtils';
import {
  PostLayoutSize,
  useIsPostLayoutSize,
} from '../../utils/responsive/PostLayoutSizeProvider';
import Emoji from './Emoji';
import ReactionAvatarStack from './ReactionAvatarStack';

const THREAD_FRAGMENT = gql(`
  fragment ReactionThreadCompact_thread on RootThreadFields {
    id
    ... on ReactionThread {
      reactions {
        id
        ...ReactionAvatarStack_reaction
      }
    }
    ... on PublicReactionThread {
      reactions {
        id
        ...ReactionAvatarStack_reaction
      }
    }
  }
`);

interface ReactionThreadCompactProps {
  thread: ExtractReactionThreadTypes<typeof THREAD_FRAGMENT>;
}

const ReactionThreadCompact = ({ thread }: ReactionThreadCompactProps) => {
  const isTablet = useIsPostLayoutSize(PostLayoutSize.tablet);

  if (isTablet) {
    const firstEmoji = thread.reactions.at(0)?.emoji;
    return firstEmoji ? <Emoji char={firstEmoji} size="medium" /> : null;
  }

  return <ReactionAvatarStack maxItemsShown={3} reactions={thread.reactions} />;
};

export default ReactionThreadCompact;
